import Marquee from "react-fast-marquee";

const Logos = ({ rootFolder }) => {
  return (
    <>
      <div className="logos">
        <Marquee speed={40} gradient={false} pauseOnHover={false} pauseOnClick={false} >
          <div className="slide"><img style={{ height: '35px' }} src={rootFolder + "images/svg/Go_Oil_logo.svg"} alt="Go Oil logo" /></div>
          <div className="slide"><img style={{ height: '35px' }} src={rootFolder + "images/svg/Hepa-logo.svg"} alt="Hepa logo" /></div>
          <div className="slide"><img style={{ height: '62px' }} src={rootFolder + "images/jpg/Jetoil-logo.jpg"} alt="Jetoil logo" /></div>
          <div className="slide"><img style={{ height: '62px' }} src={rootFolder + "images/jpg/Markoil-logo.jpg"} alt="Markoil logo" /></div>
          <div className="slide"><img style={{ height: '25px' }} src={rootFolder + "images/svg/Neste-logo.svg"} alt="Neste logo" /></div>
          <div className="slide"><img style={{ height: '62px' }} src={rootFolder + "images/png/Poweron_logo.png"} alt="Poweron logo" /></div>
          <div className="slide"><img style={{ height: '62px' }} src={rootFolder + "images/png/Terminal-logo.png"} alt="Terminal logo" /></div>
          <div className="slide"><img style={{ height: '28px' }} src={rootFolder + "images/png/Texor-logo.png"} alt="Texor logo" /></div>

          <div className="slide"><img style={{ height: '35px' }} src={rootFolder + "images/svg/Go_Oil_logo.svg"} alt="Go Oil logo" /></div>
          <div className="slide"><img style={{ height: '35px' }} src={rootFolder + "images/svg/Hepa-logo.svg"} alt="Hepa logo" /></div>
          <div className="slide"><img style={{ height: '62px' }} src={rootFolder + "images/jpg/Jetoil-logo.jpg"} alt="Jetoil logo" /></div>
          <div className="slide"><img style={{ height: '62px' }} src={rootFolder + "images/jpg/Markoil-logo.jpg"} alt="Markoil logo" /></div>
          <div className="slide"><img style={{ height: '25px' }} src={rootFolder + "images/svg/Neste-logo.svg"} alt="Neste logo" /></div>
          <div className="slide"><img style={{ height: '62px' }} src={rootFolder + "images/png/Poweron_logo.png"} alt="Poweron logo" /></div>
          <div className="slide"><img style={{ height: '62px' }} src={rootFolder + "images/png/Terminal-logo.png"} alt="Terminal logo" /></div>
          <div className="slide"><img style={{ height: '28px' }} src={rootFolder + "images/png/Texor-logo.png"} alt="Texor logo" /></div>

        </Marquee>
      </div>
    </>
  );
}

export default Logos;
